import { useTranslator } from "@eo-locale/react";

import NextLink from "next/link";
import { MdOutlineEmail } from "react-icons/md";

import {
  Button,
  Center,
  Heading,
  HStack,
  Text,
  VStack
} from "@/storybook-components";
import useAuthGate from "@/hooks/useAuthGate";

interface SurveyGuestLoginGateProps {
  getRoute: (route: "login" | "register") => string;
  getRouteTarget: () => string;
}

const SurveyGuestLoginGate = ({
  getRoute,
  getRouteTarget
}: SurveyGuestLoginGateProps): JSX.Element => {
  const { translate } = useTranslator();
  const { openGuestLoginModal } = useAuthGate();

  const handleContinueWithEmail = () => {
    openGuestLoginModal({ initialStep: "email-login" });
  };

  return (
    <Center py={8} data-testid="survey-guest-login-gate">
      <VStack
        gap={6}
        maxW="450px"
        width="100%"
        align="center"
        textAlign="center"
      >
        <VStack gap={3}>
          <Heading
            as="h2"
            size="md"
            data-testid="survey-guest-login-gate-headline"
          >
            {translate("survey.verifyYourEmailToTakeThisSurvey")}
          </Heading>
          <Text
            color="gray.600"
            data-testid="survey-guest-login-gate-description"
          >
            {translate("survey.weWillSendYouATimeCodeTakesLessThanAMinute")}
          </Text>
        </VStack>
        <VStack align="stretch" gap={3}>
          <Button
            variant="primary"
            leftIcon={<MdOutlineEmail />}
            onClick={handleContinueWithEmail}
            data-testid="survey-guest-login-gate-continue-with-email"
          >
            {translate("survey.continueWithEmail")}
          </Button>
          <HStack>
            <Text>{translate("survey.alreadyHaveAnAccount")}</Text>
            <NextLink href={getRoute("login")} target={getRouteTarget()}>
              <Button
                variant="link"
                data-testid="survey-guest-login-gate-sign-in"
              >
                {translate("survey.signIn")}
              </Button>
            </NextLink>
          </HStack>
        </VStack>
      </VStack>
    </Center>
  );
};

export default SurveyGuestLoginGate;
